import "./App.css";
import { Page0 } from "./page/page0";
import { Page0A } from "./page/page0A";
import { Page1 } from "./page/page1";
import { Page1A } from "./page/page1A";
import { Page2 } from "./page/page2";
import { Page2A } from "./page/page2A";
import { Page3 } from "./page/page3";
import { Page3A } from "./page/page3A";
import { Page4 } from "./page/page4";
import { Page4A } from "./page/page4A";
import { Login } from "./page/login";
import { Consent } from "./page/consent";
import { Instructions } from "./page/instructions";
import { Instructions2 } from "./page/instructions2";
import { Questionnaire } from "./page/questionnaire";
import { Endscreen } from "./page/endscreen";
import { Screenlimit } from "./page/screenlimit";
import { Transition } from "./page/transition";
import { Start } from "./page/start";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function MyComponent() {
}

function App() {
  const MIN_WIDTH = 760; // minimum width in pixels
  const history = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth < MIN_WIDTH) {
        history("/screenlimit"); // redirect to the small screen page
      }
    };
    window.addEventListener("resize", handleResize); // add listener to window resize event
    handleResize(); // check window size on component mount
    return () => {
      window.removeEventListener("resize", handleResize); // remove listener on unmount
    };
  }, [history, MIN_WIDTH]);

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function(event) {
      window.history.pushState(null, document.title, window.location.href);
    });
  }, [history]);

  return (
  <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/consent" element={<Consent />} />
        <Route path="/instructions" element={<Instructions />} />
        <Route path="/instructions2" element={<Instructions2 />} />
        <Route path="/page0" element={<Page0 />} />
        <Route path="/page0A" element={<Page0A />} />
        <Route path="/page1" element={<Page1 />} />
        <Route path="/page1A" element={<Page1A />} />
        <Route path="/page2" element={<Page2 />} />
        <Route path="/page2A" element={<Page2A />} />
        <Route path="/page3" element={<Page3 />} />
        <Route path="/page3A" element={<Page3A />} />
        <Route path="/page4" element={<Page4 />} />
        <Route path="/page4A" element={<Page4A />} />
        <Route path="/questionnaire" element={<Questionnaire />} />
        <Route path="/endscreen" element={<Endscreen />} />
        <Route path="/screenlimit" element={<Screenlimit />} />
        <Route path="/transition" element={<Transition />} />
        <Route path="/start" element={<Start />} />
      </Routes>
    </div>
  );
}

export default App;
